import designService from "api/design/design.service";
import { IUpscaleImageRequest } from "api/design/design.type";
import { rememberOwnedDownload } from "components/SocketListener/pendingDownloads";

/**
 * REF-6877: start an SVG conversion or a 4K upscale whose result `SocketListener` auto-downloads. Each starts the
 * request and records its id as owned by this tab (`pendingDownloads`), then hands the response back unchanged —
 * every caller keeps its own `_handled` / already-4K / error handling. A caller that must keep the literal service
 * call (FloatingInfoPanel's `handleDownloadAsSvg`, pinned by captureOwnership.rawSites) calls
 * `rememberOwnedDownload` itself right after it.
 */
export const requestOwnedSvgConversion = async (input_image: string) => {
  const res = await designService.convertToSvg({ input_image });
  rememberOwnedDownload("get_vector_file", res);

  return res;
};

export const requestOwned4kDownload = async (data: IUpscaleImageRequest) => {
  const res = await designService.upscaleImage(data);
  rememberOwnedDownload("upscale_image", res);

  return res;
};
